import { api } from "@/lib/api";

const CHUNK = 4 * 1024 * 1024;

function toBase64(blob) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result.split(",")[1]);
    r.onerror = reject;
    r.readAsDataURL(blob);
  });
}

// Chunked upload (bypasses proxy body limits). Returns the stored file record.
export async function uploadInChunks(file, { purpose = "general", ref_id = null, caption = "" } = {}, onProgress) {
  const upload_id = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  for (let index = 0; index < total; index++) {
    const data = await toBase64(file.slice(index * CHUNK, (index + 1) * CHUNK));
    await api.post("/files/chunk", { upload_id, index, total, data });
    onProgress?.(Math.round(((index + 1) / total) * 90));
  }
  const { data } = await api.post("/files/complete", { upload_id, filename: file.name, content_type: file.type, purpose, ref_id, caption });
  onProgress?.(100);
  return data;
}

export async function downloadFile(fileId, filename) {
  const r = await api.get(`/files/${fileId}`, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url; a.download = filename || "download"; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

export function formatBytes(n) {
  if (!n && n !== 0) return "";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}
